import React from 'react'
import PropTypes from 'prop-types'
import { Row } from '@sainsburys-tech/bolt'
import { ComponentHelper } from '../../../helpers/ComponentHelper'
import { GetComponent } from '../../CMSComponents'
import * as Styled from './GL003.styles'

/**
 * - GL003 is the offers grid.
 * - It splits the rows in a mixture of 2/3 and 1/3 sections which can be used to slot in the components.
 * - It's primarily used on Argos on the CLPs (Content Lister Pages).
 */
const GL003 = ({ offers, navigation, onLinkClick }) => {
  if (!navigation) return null

  const navigationProps = {
    navigation: navigation[0],
    offers,
    onLinkClick
  }
  return (
    <>
      <Row row='lg' hidden='xs' lg={12} negative='md' data-test='gl003-container-lg'>
        {!!offers &&
          offers.map((component, index) => {
            const offerSize = ComponentHelper.gridLayout('GL003', index, offers.length)
            const columnProps = { md: offerSize }
            const key = [`gl003-key-${index}`]
            const props = {
              columnProps,
              offerSize,
              key,
              onLinkClick,
              consumingGrid: 'gl003'
            }
            return <GetComponent key={`gl003-component-${index}`} {...{ ...component, ...props }} />
          })}
      </Row>
      <Styled.MobileWrapper row='xs' gutterValue={0} gutterSize='15px' negative='xs' data-test='gl003-container-xs'>
        <GetComponent {...{ ...navigation[0], ...navigationProps }} />
      </Styled.MobileWrapper>
    </>
  )
}

GL003.propTypes = {
  /** Array of data containing the image and navigation info for each of the offers */
  navigation: PropTypes.array,
  /** Array of data used to render the offer components within the grid */
  offers: PropTypes.array,
  /** Optional prop to handle onClick of any of the child components */
  onLinkClick: PropTypes.func
}

GL003.defaultProps = {
  navigation: [],
  offers: [],
  onLinkClick: null
}

export default GL003
